<template>
  <span class="inline-block relative">
    <img
      src="/graphics/purple/underline-1.svg"
      alt="Purple squiggle underline"
      class="absolute w-full -bottom-1/4"
      height="40"
      width="160"
    />
    <span class="relative z-10">
      <slot></slot>
    </span>
  </span>
</template>
